import PropTypes from "prop-types";
import { useTranslation } from "next-i18next";
import { useStateMachine } from "little-state-machine";
import { Accordion } from "@components/Accordion";
import { SimpleBlockContent } from "@components/SimpleBlockContent";
import styles from "./styles/details.module.css";

export function Details({ settings }) {
  const { state } = useStateMachine();
  const { t } = useTranslation("productpage");

  const SHIPPING = t("shipping-accordion-title");
  const isGiftCard = state["product"].productReferenceV2.handle.toLowerCase() === "gift-card";

  // NOTE: the details are read in reverse order, which is what slice and reverse is doing.
  return (
    <div className={styles.container}>
      {state["productGroup"].details &&
        state["productGroup"].details.slice(0).reverse().map((detail) => (
          <Accordion title={detail.detailTitle} key={detail._key}>
            <SimpleBlockContent blocks={detail.detailContent} />
          </Accordion>
        ))}
      {settings && settings.shippingInfo && !isGiftCard && (
        <Accordion title={SHIPPING}>
          <SimpleBlockContent blocks={settings.shippingInfo} />
        </Accordion>
      )}
    </div>
  );
}

Details.propTypes = {
  settings: PropTypes.object.isRequired,
};
